import styled from "styled-components"

const NavigationTab = styled.div`
  margin: 0;
  list-style: none;
  display: flex;
  align-items: center;
  height: 97px;
  width: 194px;
  z-index: -1;
  position: absolute;
  margin-left: -97px;
  left: 50%;
  bottom: -97px;
  overflow: hidden;
  cursor: pointer;
`

export default NavigationTab



// WEBPACK FOOTER //
// ./src/Kiosk/Navigator/NavigationTab.js